// Components
import { Button, Input, Modal } from "components"
import { Detail } from "../../PurchaseOrder/components"

// Icons
import { TbInfoCircle } from "react-icons/tb"

// Utils
import { useToggle } from "utils"

export function LinkToPurchase(params: {
  trx_code: string
  purchase_order_id: string
}): JSX.Element {
  return (
    <section className="flex items-end">
      <section className="grow">
        <Input
          disabled
          inputClass="rounded-r-none"
          label="LINK TO PURCHASE ID"
          value={params.trx_code}
        />
      </section>

      <DetailSection purchase_order_id={params.purchase_order_id} />
    </section>
  )
}

function DetailSection(params: {
  purchase_order_id: string
}): JSX.Element {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <>
      <Button
        type="button"
        color="primary"
        onClick={toggle}
      >
        <TbInfoCircle />
      </Button>

      {isActive && (
        <Modal
          isOpen
          title="PURCHASE ORDER DETAIL"
          closeModal={toggle}
        >
          <Modal.Body>
            <Detail purchase_order_id={params.purchase_order_id} />
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}